import { PropsWithChildren, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { Icon } from '@/Components/UI/Icon';
import { Heading } from '@/Components/UI/Heading';

type ItemProps = PropsWithChildren<{
    title: string;
    initialOpen?: boolean;
}>

export const Item = ({ title, initialOpen = false, children }: ItemProps) => {
    const [isOpen, setIsOpen] = useState(initialOpen);

    return (
        <div className={'group'}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={twMerge(
                    'flex items-center justify-between w-full mb-1 p-5 bg-surface-1 text-on-surface hover:bg-surface-2 font-medium text-left transition-colors duration-200 ease-in-out group-first:rounded-t-lg group-last:rounded-b-lg',
                    isOpen && 'bg-surface-3 group-last:rounded-b-none'
                )}>
                <Heading
                    level={3}
                    className={'my-0'}>
                    {title}
                </Heading>

                <Icon name={'chevron_right'} className={twMerge(
                    'transition-transform duration-200 ease-in-out',
                    isOpen && 'rotate-90'
                )} />
            </button>

            {isOpen && (
                <div className={'mb-1 p-5 bg-surface-1 text-on-surface group-last:rounded-b-lg'}>
                    {children}
                </div>
            )}
        </div>
    );
};
